import { defineMessages } from 'react-intl';

export default defineMessages({
    manageStudents: {
        id: 'app.components.EditClassGroup.manageStudents',
        defaultMessage: 'Manage students'
    },
    changeCourse: {
        id: 'app.components.EditClassGroup.changeCourse',
        defaultMessage: 'Change course'
    },
    renameGroup: {
        id: 'app.components.EditClassGroup.renameGroup',
        defaultMessage: 'Rename group'
    },
    delete: {
        id: 'app.components.EditClassGroup.delete',
        defaultMessage: 'Delete group'
    },
    close: {
        id: 'app.components.EditClassGroup.close',
        defaultMessage: 'Close'
    },
    deleting: {
        id: 'app.components.EditClassGroup.deleting',
        defaultMessage: 'Deleting'
    },
    deleteNonEmptyGroupConfirmation: {
        id: 'app.components.EditClassGroup.deleteNonEmptyGroupConfirmation',
        defaultMessage: 'must be empty before it can be deleted.'
    },
    pleaseGoTo: {
        id: 'app.components.EditClassGroup.pleaseGoTo',
        defaultMessage: 'Please go to'
    },
    toMoveYourStudents: {
        id: 'app.components.EditClassGroup.toMoveYourStudents',
        defaultMessage: 'to move your students.'
    },
    AreYouSureYouWantToDelete: {
        id: 'app.components.EditClassGroup.AreYouSureYouWantToDelete',
        defaultMessage: 'Are you sure you want to delete '
    },
    doYouWishTo: {
        id: 'app.components.EditClassGroup.doYouWishTo',
        defaultMessage: 'Do you wish to rename the group'
    },
    to: {
        id: 'app.components.EditClassGroup.to',
        defaultMessage: 'to'
    },
    questionMark: {
        id: 'app.components.EditClassGroup.questionMark',
        defaultMessage: '?'
    },
    yourGroup: {
        id: 'app.components.EditClassGroup.yourGroup',
        defaultMessage: 'Your group, '
    },
    hasBeenDeleted: {
        id: 'app.components.EditClassGroup.hasBeenDeleted',
        defaultMessage: ', has been deleted.'
    }
});



// WEBPACK FOOTER //
// ./app/components/edit-class-group/messages.js